import { render, staticRenderFns } from "./level.vue?vue&type=template&id=1ec65fa8&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"
import style0 from "./level.vue?vue&type=style&index=0&id=1ec65fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec65fa8",
  null
  
)

export default component.exports